<div class="mat-app-background">
  <mat-card appearance="raised" [ngClass]="{'sticky-heading': (stickyHeader$ | async)}">
    <mat-progress-bar class="progress-loader"
      [mode]="loadingIndicator ? 'indeterminate' : 'determinate'" value="0"
    color="primary"></mat-progress-bar>
    <mat-card-content class="header-card">
      <div class="control-panel-container">
        <div class="control-panel-header">
          <h1>Settings</h1>
        </div>
      </div>
      @if (hasRoleAsync('ROLE_ADMIN') | async) {
        <div>
          <button matButton="filled" (click)="!isEditing ? edit() : save()">{{!isEditing ? 'EDIT' : 'SAVE'}}</button>
          @if (isEditing) {
            <button matButton="tonal" (click)="cancel()" style="margin-left: 12px;">
              CANCEL
            </button>
          }
        </div>
      }

    </mat-card-content>
  </mat-card>

  <mat-card appearance="raised" class="panel">
    <mat-card-subtitle>App Settings</mat-card-subtitle>
    <mat-card-content>
      <section >
        <mat-slide-toggle
          color="primary"
          [checked]="(darkMode$ | async)"
          (change)="updateDarkMode($event)"
          >
          Dark Mode
        </mat-slide-toggle>
        <mat-slide-toggle
          style="margin-left: 16px"
          color="primary"
          [checked]="(stickyHeader$ | async)"
          (change)="updateStickyHeader($event)"
          >
          Sticky Header
        </mat-slide-toggle>
      </section>
    </mat-card-content>
  </mat-card>
  @if ((authenticated$ | async) && (hasRoleAsync('ROLE_ADMIN') | async) && organizationForm) {
    <ng-container [formGroup]="organizationForm">
      <mat-card appearance="raised" class="panel">
        <mat-card-subtitle>Organization Settings</mat-card-subtitle>
        <mat-card-content>
          <section style="display: flex; flex-direction: column;">
            <mat-form-field subscriptSizing="fixed" provideReadonly appearance="fill">
              <mat-label>Name</mat-label>
              <input matInput [readonly]="!isEditing" formControlName="name">
            </mat-form-field>
            <mat-form-field subscriptSizing="fixed" provideReadonly appearance="fill">
              <mat-label>Description</mat-label>
              <input matInput [readonly]="!isEditing" formControlName="description">
            </mat-form-field>
            <mat-form-field subscriptSizing="fixed" provideReadonly appearance="fill">
              <mat-label>Region</mat-label>
              <input matInput [readonly]="true" formControlName="region">
            </mat-form-field>
            <mat-form-field subscriptSizing="fixed" provideReadonly appearance="fill">
              <mat-label>Currency</mat-label>
              <input matInput [readonly]="true" formControlName="currency">
            </mat-form-field>
            <mat-form-field subscriptSizing="fixed" provideReadonly appearance="fill">
              <mat-label>Default Color</mat-label>
              <input matInput [readonly]="!isEditing" formControlName="defaultColor">
            </mat-form-field>
          </section>
        </mat-card-content>
      </mat-card>
      <mat-card appearance="raised" class="panel">
        <mat-card-subtitle>Bank Details</mat-card-subtitle>
        <mat-card-content>
          <section style="display: flex; flex-direction: column;" [formGroup]="organizationForm.get('bankDetails').value">
            <mat-form-field subscriptSizing="fixed" provideReadonly appearance="fill">
              <mat-label>Bank</mat-label>
              <input matInput [readonly]="!isEditing" formControlName="bank">
            </mat-form-field>
            <mat-form-field subscriptSizing="fixed" provideReadonly appearance="fill">
              <mat-label>Branch Code</mat-label>
              <input matInput [readonly]="!isEditing" formControlName="branchCode">
            </mat-form-field>
            <mat-form-field subscriptSizing="fixed" provideReadonly appearance="fill">
              <mat-label>Account Number</mat-label>
              <input matInput [readonly]="!isEditing" formControlName="accountNumber">
            </mat-form-field>
            <mat-form-field subscriptSizing="fixed" provideReadonly appearance="fill">
              <mat-label>Account Type</mat-label>
              <input matInput [readonly]="!isEditing" formControlName="accountType">
            </mat-form-field>
            <mat-form-field subscriptSizing="fixed" provideReadonly appearance="fill">
              <mat-label>Swift Code</mat-label>
              <input matInput [readonly]="!isEditing" formControlName="swiftCode">
            </mat-form-field>
          </section>
        </mat-card-content>
      </mat-card>
      <mat-card appearance="raised" class="panel">
        <mat-card-subtitle>Tax Information</mat-card-subtitle>
        <mat-card-content>
          <section style="display: flex; flex-direction: column;">
            <mat-form-field subscriptSizing="fixed" provideReadonly appearance="fill">
              <mat-label>Tax Percentage</mat-label>
              <input matInput [readonly]="!isEditing" formControlName="taxPercentage">
            </mat-form-field>
            <mat-checkbox style="margin: 0 12px;" formControlName="includeTax">Tax Enabled</mat-checkbox>
          </section>
        </mat-card-content>
      </mat-card>
      <mat-card appearance="raised" class="panel">
        <mat-card-subtitle>Addresses</mat-card-subtitle>
        <mat-card-content>
          <section style="display: flex; flex-direction: row;">
            <section style="flex: 1; display: flex; flex-direction: column; margin-right: 12px" [formGroup]="organizationForm.get('pickupAddress').value">
              <mat-card-subtitle>Pickup Address</mat-card-subtitle>
              <mat-form-field subscriptSizing="fixed" provideReadonly appearance="fill">
                <mat-label>Line 1</mat-label>
                <input matInput [readonly]="!isEditing" formControlName="line1">
              </mat-form-field>
              <mat-form-field subscriptSizing="fixed" provideReadonly appearance="fill">
                <mat-label>Line 2</mat-label>
                <input matInput [readonly]="!isEditing" formControlName="line2">
              </mat-form-field>
              <mat-form-field subscriptSizing="fixed" provideReadonly appearance="fill">
                <mat-label>Complex</mat-label>
                <input matInput [readonly]="!isEditing" formControlName="complex">
              </mat-form-field>
              <mat-form-field subscriptSizing="fixed" provideReadonly appearance="fill">
                <mat-label>Suburb</mat-label>
                <input matInput [readonly]="!isEditing" formControlName="suburb">
              </mat-form-field>
              <mat-form-field subscriptSizing="fixed" provideReadonly appearance="fill">
                <mat-label>City</mat-label>
                <input matInput [readonly]="!isEditing" formControlName="city">
              </mat-form-field>
              <mat-form-field subscriptSizing="fixed" provideReadonly appearance="fill">
                <mat-label>State</mat-label>
                <input matInput [readonly]="!isEditing" formControlName="state">
              </mat-form-field>
              <mat-form-field subscriptSizing="fixed" provideReadonly appearance="fill">
                <mat-label>Postal Code</mat-label>
                <input matInput [readonly]="!isEditing" formControlName="postalCode">
              </mat-form-field>
            </section>
            <section style="flex: 1; display: flex; flex-direction: column" [formGroup]="organizationForm.get('billingAddress').value">
              <mat-card-subtitle>Billing Address</mat-card-subtitle>
              <mat-form-field subscriptSizing="fixed" provideReadonly appearance="fill">
                <mat-label>Line 1</mat-label>
                <input matInput [readonly]="!isEditing" formControlName="line1">
              </mat-form-field>
              <mat-form-field subscriptSizing="fixed" provideReadonly appearance="fill">
                <mat-label>Line 2</mat-label>
                <input matInput [readonly]="!isEditing" formControlName="line2">
              </mat-form-field>
              <mat-form-field subscriptSizing="fixed" provideReadonly appearance="fill">
                <mat-label>Complex</mat-label>
                <input matInput [readonly]="!isEditing" formControlName="complex">
              </mat-form-field>
              <mat-form-field subscriptSizing="fixed" provideReadonly appearance="fill">
                <mat-label>Suburb</mat-label>
                <input matInput [readonly]="!isEditing" formControlName="suburb">
              </mat-form-field>
              <mat-form-field subscriptSizing="fixed" provideReadonly appearance="fill">
                <mat-label>City</mat-label>
                <input matInput [readonly]="!isEditing" formControlName="city">
              </mat-form-field>
              <mat-form-field subscriptSizing="fixed" provideReadonly appearance="fill">
                <mat-label>State</mat-label>
                <input matInput [readonly]="!isEditing" formControlName="state">
              </mat-form-field>
              <mat-form-field subscriptSizing="fixed" provideReadonly appearance="fill">
                <mat-label>Postal Code</mat-label>
                <input matInput [readonly]="!isEditing" formControlName="postalCode">
              </mat-form-field>
            </section>
          </section>
        </mat-card-content>
      </mat-card>
      <mat-card appearance="raised" class="panel">
        <mat-card-subtitle>Email Addresses</mat-card-subtitle>
        <mat-card-content>
          <section style="display: flex; flex-direction: column;">
            <mat-form-field subscriptSizing="fixed" provideReadonly appearance="fill">
              <mat-label>From Email</mat-label>
              <input matInput [readonly]="!isEditing" formControlName="fromEmail">
            </mat-form-field>
            <mat-form-field subscriptSizing="fixed" provideReadonly appearance="fill">
              <mat-label>Inbox Email</mat-label>
              <input matInput [readonly]="!isEditing" formControlName="inboxEmail">
            </mat-form-field>
          </section>
        </mat-card-content>
      </mat-card>
      <mat-card appearance="raised" class="panel">
        <mat-card-subtitle>Contact Info</mat-card-subtitle>
        <mat-card-content>
          <section style="display: flex; flex-direction: column;">
            <mat-form-field subscriptSizing="fixed" provideReadonly appearance="fill">
              <mat-label>Phone Number</mat-label>
              <input matInput [readonly]="!isEditing" formControlName="phoneNumber">
            </mat-form-field>
          </section>
        </mat-card-content>
      </mat-card>
      <mat-card appearance="raised" class="panel">
        <mat-card-subtitle>Website Settings</mat-card-subtitle>
        <mat-card-content>
          <section style="display: flex; flex-direction: column;">
            <mat-form-field subscriptSizing="fixed" provideReadonly appearance="fill">
              <mat-label>InvFlow Url</mat-label>
              <input matInput [readonly]="!isEditing" formControlName="invflowUrl">
            </mat-form-field>
            <mat-form-field subscriptSizing="fixed" provideReadonly appearance="fill">
              <mat-label>Logo Url</mat-label>
              <input matInput [readonly]="!isEditing" formControlName="logoUrl">
            </mat-form-field>
            <mat-form-field subscriptSizing="fixed" provideReadonly appearance="fill">
              <mat-label>Website</mat-label>
              <input matInput [readonly]="!isEditing" formControlName="website">
            </mat-form-field>
            <mat-form-field subscriptSizing="fixed" provideReadonly appearance="fill">
              <mat-label>Reset Password Url</mat-label>
              <input matInput [readonly]="!isEditing" formControlName="website">
            </mat-form-field>
          </section>
        </mat-card-content>
      </mat-card>
      <mat-card appearance="raised" class="panel">
        <mat-card-subtitle>Crypto Settings</mat-card-subtitle>
        <mat-card-content>
          <section style="display: flex; flex-direction: column;">
            <mat-form-field subscriptSizing="fixed" provideReadonly appearance="fill">
              <mat-label>Crypto Key</mat-label>
              <input matInput [readonly]="!isEditing" formControlName="cryptoKey">
            </mat-form-field>
            <mat-form-field subscriptSizing="fixed" provideReadonly appearance="fill">
              <mat-label>Crypto IV</mat-label>
              <input matInput [readonly]="!isEditing" formControlName="cryptoIv">
            </mat-form-field>
          </section>
        </mat-card-content>
      </mat-card>
    </ng-container>
  }
</div>

